import React from 'react';
import { Flex, Heading, Semibold, Text } from '@marvelapp/ui';
/** @param {any} */
export default function SidebarFilterEmptyState(_a) {
    var filterText = _a.filterText, type = _a.type;
    return (React.createElement(Flex, { alignItems: "center", "data-testid": "".concat(type, "-list-empty-filter"), flexDirection: "column", height: "100%", justifyContent: "center", textAlign: "center" },
        React.createElement(Heading, { fontSize: 3, fontWeight: 500 }, "Try another search"),
        React.createElement(Text, { fontSize: 2, marginTop: 1 },
            "No ",
            type,
            "s matching ",
            React.createElement(Semibold, null, filterText))));
}
